
import { defineComponent, ref, reactive } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  setup() {
    const router = useRouter();
    const goback = () => {
      router.go(-1);
    };
    const count = ref(800);
    const star = ref();
    const getStart = () => {
      setTimeout(() => {
        star.value.forEach((item: any) => {
          let speed = 0.2 + Math.random() * 1;
          let thisDistance = count.value + Math.random() * 300;
          item.style.transformOrigin = `0 0 ${thisDistance}px`;
          item.style.transform = `translate3d(0, 0, -${thisDistance}px) rotateY(${Math.random() * 360}deg) rotateX(${
            Math.random() * -50
          }deg) scale(${speed}, ${speed})`;
        });
      }, 1000);
    };
    getStart();
    return { goback, star };
  },
});
